import React from "react";

const Logo = ({ className, alt, src, ...props }) => {
  return (
    <img
      className={className}
      src={src ? src : "/logo.png"}
      alt={alt ? alt : "Logo"}
      {...props}
    />
  );
};

export default Logo;
